module.exports = __webpack_public_path__ + "static/media/Alana-main-payment.34604320.png";